import React from "react";
import {
  OptionsGrid,
  OptionCard,
  OptionIcon,
  OptionTitle,
  OptionDescription,
  RecommendedBadge,
} from "../choose-profile.styles";

const InitSetup = ({ onManualSetup, onAISetup }) => (
  <OptionsGrid>
    <OptionCard onClick={onAISetup}>
      <RecommendedBadge>Recommended</RecommendedBadge>
      <OptionIcon $bg="rgba(168, 85, 247, 0.1)" $color="#a855f7">
        <i className="pi pi-sparkles" />
      </OptionIcon>
      <OptionTitle>Import with AI</OptionTitle>
      <OptionDescription>
        Upload your resume and let AI extract your info automatically.
      </OptionDescription>
    </OptionCard>

    <OptionCard onClick={onManualSetup}>
      <OptionIcon>
        <i className="pi pi-pencil" />
      </OptionIcon>
      <OptionTitle>Fill manually</OptionTitle>
      <OptionDescription>
        Enter your education, experience, and skills step by step.
      </OptionDescription>
    </OptionCard>
  </OptionsGrid>
);

export default InitSetup;
